export default {
	init() {
		const tabContainers = document.querySelectorAll(".block-tabs");

		if (!tabContainers.length) return;

		tabContainers.forEach((container) => {
			const headers = container.querySelectorAll(".block-tab-header");
			const mobileItems = container.querySelectorAll(".dropdown-li");
			const panels = container.querySelectorAll(".block-tab");
			const mobileLabel = container.querySelector(".block-tabs-headers__mobile--label");
			const mobileDropdown = container.querySelector(".block-tabs-headers__mobile--dropdown");

			// init state
			const activateTab = (targetId) => {
				panels.forEach((panel) => {
					panel.style.display = "none";
					panel.classList.remove("active");
				});

				headers.forEach((h) => h.classList.remove("active"));

				const targetPanel = container.querySelector(`#${targetId}`);
				if (targetPanel) {
					targetPanel.style.display = "block";
					targetPanel.classList.add("active");
				}

				// sync desktop active header
				const activeHeader = container.querySelector(
					`.block-tab-header[aria-controls="${targetId}"]`
				);
				if (activeHeader) {
					activeHeader.classList.add("active");
				}

				// sync mobile label (optional)
				const label = container.querySelector(".block-tabs-headers__mobile--label");
				if (label && activeHeader) {
					label.childNodes[0].nodeValue = activeHeader.textContent;
				}

				if (mobileDropdown) {
					mobileDropdown.classList.remove("open");
				}

				if (mobileLabel) {
					mobileLabel.classList.remove("active");
				}
			};

			// default active = first tab
			const firstHeader = headers[0];
			if (firstHeader) {
				activateTab(firstHeader.getAttribute("aria-controls"));
			}

			// desktop click
			headers.forEach((header) => {
				header.addEventListener("click", () => {
					activateTab(header.getAttribute("aria-controls"));
				});
			});

			// mobile click
			mobileItems.forEach((item) => {
				item.addEventListener("click", () => {
					activateTab(item.getAttribute("aria-controls"));
				});
			});

			if (mobileLabel && mobileDropdown) {
				mobileLabel.addEventListener("click", (e) => {
					e.stopPropagation();

					mobileDropdown.classList.toggle("open");
					mobileLabel.classList.toggle("active");
				});

				// click outside closes
				document.addEventListener("click", (e) => {
					if (!container.contains(e.target)) {
						mobileDropdown.classList.remove("open");
						mobileLabel.classList.remove("active");
					}
				});
			}
		});
	},
};